var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDesign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "100 100 178 90.779",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#9EFF7B",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 100 105 C 100 102.239 102.238 100 105 100 L 273 100 C 275.761 100 278 102.239 278 105 L 278 133 L 100 133 L 100 105 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 278 129.779 C 278 137.789 275.698 145.722 271.225 153.122 C 266.753 160.523 260.197 167.248 251.933 172.912 C 243.668 178.577 233.857 183.07 223.059 186.135 C 212.261 189.201 200.688 190.779 189 190.779 C 177.312 190.779 165.739 189.201 154.941 186.135 C 144.143 183.07 134.332 178.577 126.067 172.912 C 117.803 167.248 111.247 160.523 106.774 153.122 C 102.302 145.722 100 137.789 100 129.779 L 189 129.779 L 278 129.779 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesign);
export default __webpack_public_path__ + "static/media/Design.4b2410654d97773e29d75bdab874705f.svg";
export { ForwardRef as ReactComponent };